<template>
    <customModal :containersm="true" @closeModal="closeModal">
        <template #title>
            {{ isEditMode ? $t('navigations.update cycle') : $t('navigations.create cycle') }}
        </template>

        <template #body>
            <div class="row">
                   <!-- Cycle Id -->
                <div class="col-md-6 form-group mb-2">
                    <label class="mb-0">
                        {{ $t('navigations.cycle id') }}
                        <sup><i class="fa fa-asterisk required"></i></sup>
                    </label>
                    <input
                        v-model.number="newCycle.cycleId"
                        class="form-control"
                        :disabled="isEditMode"
                        type="number"
                        min="1"
                        @input="normalizeMinValue('cycleId')"
                    />
                    <span v-if="errors.cycleId" class="errormsg ml-0">
                        {{ errorMessages.cycleId }}
                    </span>
                </div>
                <!-- Cycle Name -->
                <div class="col-md-6 form-group mb-2">
                    <label class="mb-0">
                        {{ $t('navigations.cycle name') }}
                        <sup><i class="fa fa-asterisk required"></i></sup>
                    </label>
                    <input
                        v-model="newCycle.cycleName"
                        class="form-control"
                        :disabled="isEditMode"
                        type="text"
                    />
                    <span v-if="errors.cycleName" class="errormsg ml-0">
                        {{ errorMessages.cycleName }}
                    </span>
                </div>

                  <!-- Cycle Prefix -->
                 <div class="col-md-4 form-group mb-2">
                    <label class="mb-0">{{ $t('navigations.cycle prefix') }}</label>
                    <input
                        v-model="newCycle.cyclePrefix"
                        class="form-control"
                        type="text"
                    />
                </div>

                <!-- Arm Code -->
                <div class="col-md-4 form-group mb-2">
                    <label class="mb-0">{{ $t('navigations.arm code') }}</label>
                    <select v-model="newCycle.armCode" class="form-select">
                        <option value="">Select</option>
                        <option
                        v-for="arm in armList"
                        :key="arm.ArmCode"
                        :value="arm.ArmCode"
                        >
                        {{ arm.ArmCode }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4 form-group mb-2">
                    <label class="mb-0">
                        {{ $t('navigations.cycle duration') }} {{ $t('navigations.days') }}
                    <!-- <sup><i class="fa fa-asterisk required"></i></sup> -->
                    </label>

                    <input
                    v-model.number="newCycle.cycleDuration"
                    class="form-control"
                    type="number"
                    min="1"
                    @input="normalizeMinValue('cycleDuration')"
                    placeholder=""
                    />
       
               </div>

                <div class="col-md-6 form-group mb-2">
                    <label class="mb-0">{{ $t('navigations.parent cycle') }}</label>

                    <select v-model="newCycle.parentCycleId" class="form-select">
                        <option value="null">Select</option>
                        <option
                        v-for="cycle in cycleList"
                        :key="cycle.cycleId"
                        :value="cycle.cycleId"
                        >
                        {{ cycle.cycleName }}
                        </option>
                    </select>
                    
                </div> 
                       
                <!-- Cycle Type -->
                <div class="col-md-6 form-group mb-2">
                    <label class="mb-0">{{ $t('navigations.cycle type') }}</label>
                    
                    <select v-model="newCycle.cycleTypeCode" class="form-select">
                        <option value="">Select</option>
                        <option
                            v-for="cycle in cycleTypeList"
                            :key="cycle.cycleTypeCode"
                            :value="cycle.cycleTypeCode"
                        >
                            {{ cycle.cycleTypeName }}
                        </option>
                    </select>
                </div>
               <!-- Cycle Order -->
                <div class="col-md-4 form-group mb-2">
                    <label class="mb-0">
                        {{ $t('navigations.cycle order') }}
                    </label>
                    <input
                        v-model.number="newCycle.cycleOrder"
                        class="form-control"
                        type="number"
                        min="1"
                        @input="normalizeMinValue('cycleOrder')"
                    />
                </div>

                

                <!-- Min Repeats -->
                <div class="col-md-4 form-group mb-2" v-if="newCycle.isRepeatable">
                    <label class="mb-0">{{ $t('navigations.min repeats') }}</label>
                    <input
                        v-model.number="newCycle.minRepeats"
                        class="form-control"
                        type="number"
                        min="0"
                    />
                </div>

                <!-- Max Repeats -->
                <div class="col-md-4 form-group mb-2" v-if="newCycle.isRepeatable">
                    <label class="mb-0">{{ $t('navigations.max repeats') }}</label>
                    <input
                        v-model.number="newCycle.maxRepeats"
                        class="form-control"
                        type="number"
                        min="0"
                    />
                </div>
                <!-- Repeatable -->
                <div class="col-md-6 form-group mb-2">
                    <label class="mb-0" style="margin-top:20px">
                        <input
                            type="checkbox"
                            v-model="newCycle.isRepeatable"
                            class="mr-1"
                        />
                        {{ $t('navigations.is repeatable') }}
                    </label>
                </div>
                 <div class="text-right">
                <button
                    class="save_btn py-2 px-4 position-relative"
                  @click="submitCycle"
                >
                    {{ isEditMode ? 'Update' : 'Create' }}
                </button>
            </div>
            </div>
        </template>
    </customModal>
</template>

<script src="../Cycles/CycleModal.js"></script>
